import { httpClient } from "@services/api/httpClient";

const initiateOfferApplicant = async (offerId: number, email: string, language: string) => {
    const response = await httpClient.post("/offer-applicant/initiate", {
        offerId,
        email,
        language,
    });
    return response.data;
};

export default initiateOfferApplicant;
